/*
 * Settings-bar settings, saved per user in customers.test_settings (jsonb).
 * Theme is NOT in here — it already has its own column / endpoint.
 */

export type TestSettings = {
  splitScreen: boolean;
  fontFamily: string;
  fontSize: number;
  textZoom: number;
  textAlign: string;
  contentWidth: number;
  confirmAnswerOmission: boolean;
  highlighter: boolean;
  hidePercentages: boolean;
  strikethrough: boolean;
  buttonStrikeOut: boolean;
  altMarkQuestion: boolean;
  hideExplanations: boolean;
  showTimer: boolean;
  pauseTimer: boolean;
  showVotes: boolean;
};

export const DEFAULT_TEST_SETTINGS: TestSettings = {
  splitScreen: true,
  fontFamily: "Arial",
  fontSize: 16,
  textZoom: 16,
  textAlign: "start",
  contentWidth: 1000,
  confirmAnswerOmission: true,
  highlighter: false,
  hidePercentages: false,
  strikethrough: false,
  buttonStrikeOut: false,
  altMarkQuestion: false,
  hideExplanations: false,
  showTimer: true,
  pauseTimer: false,
  showVotes: false,
};

/**
 * Turns whatever came back from the server (null, a partial object from an
 * older version, a JSON string) into a full settings object.
 * Unknown keys are dropped and wrongly-typed values fall back to the default.
 */
export function normalizeTestSettings(raw: unknown): TestSettings {
  let source: unknown = raw;
  if (typeof source === "string") {
    try {
      source = JSON.parse(source);
    } catch {
      source = null;
    }
  }

  const result: TestSettings = { ...DEFAULT_TEST_SETTINGS };
  if (!source || typeof source !== "object") return result;

  for (const key of Object.keys(DEFAULT_TEST_SETTINGS) as (keyof TestSettings)[]) {
    const value = (source as Record<string, unknown>)[key];
    if (typeof value === typeof DEFAULT_TEST_SETTINGS[key]) {
      (result as Record<string, unknown>)[key] = value;
    }
  }
  return result;
}